import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

export const InvoiceManageRecord = () => {

    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}